import { render, staticRenderFns } from "./hoja_vida.vue?vue&type=template&id=d6e0fc36"
import script from "./hoja_vida.vue?vue&type=script&lang=js"
export * from "./hoja_vida.vue?vue&type=script&lang=js"
import style0 from "./hoja_vida.vue?vue&type=style&index=0&id=d6e0fc36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports